import React, { Component } from "react";
import api from "../api";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import Link from "@material-ui/core/Link";
import InputAdornment from "@material-ui/core/InputAdornment";
import MediaFile from "../MediaFile";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ViewIcon from "@material-ui/icons/Visibility";
import CancelIcon from "@material-ui/icons/Cancel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import NumberFormat from "react-number-format";
import InputMask from "react-input-mask";
import EditIcon from "@material-ui/icons/Edit";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import { FormControl, Input, InputLabel, Select } from "@material-ui/core";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "(",
        /[0-9]/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}

const useStyles = theme => ({
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  menu: {
    fontSize: "0.75rem"
  },
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "red"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  menu: {
    fontSize: "0.75rem"
  }
});

class Sinister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      media: [{}],
      sinister_types: [],
      reclaim_types: [],
      sinister_sectors: [
        { id: "Cerraduras", name: "Cerraduras" },
        { id: "Frente", name: "Frente" },
        { id: "Laterales", name: "Laterales" },
        { id: "Neumaticos", name: "Neumaticos" },
        { id: "Otros", name: "Otros" },
        { id: "Parte Trasera", name: "Parte Trasera" },
        { id: "Vidrios", name: "Vidrios" }
      ],
      media: [{}],
      sinister_type_id: "",
      dialog: { open: false },
      documentation_expand: false,
      mails_expand: false,
      lawyer_required: false,
      total_destruction: false,
      is_reclaimable: false,
      is_insurance_reclaimable: false,
      has_voucher: false,
      saving: false,
      sinister_sector: "",
      province_id: "",
      city_id: "",
      providers: {
        loading: false,
        open: false,
        options: [{ business_name: "" }],
        provider: {}
      },
      vehicle: {
        insurance: {
          type: {
            name: ""
          }
        }
      },
      broker_contact_email: "",
      insurance: { subcontacts: [] },
      reclaims: [],
      documentation: [{}],
      contact_edit: false,
      active_booking: {},
      provinces: [],
      cities: []
    };
  }

  async componentDidMount() {
    var plate = this.props.plate;
    var work_order_id = this.props.work_order_id;
    var sinister_types = await this.getSinisterTypes();

    var reclaim_types = this.getWorkOrderAlertsReclaimTypes();
    var provinces = await this.getProvinces();
    await this.getSinister(work_order_id);
    if (!this.state.id) {
      var insurance = await this.getInsuranceByPlate(plate);
    }
    this.setState({ active_booking: this.props.booking });
  }

  getProvinces = async () => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.provinces().get(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var provinces = res.data;
        this.setState({ provinces: provinces });
      });
  };

  getCities = async province_id => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.provinces().cities(province_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var cities = res.data;
        this.setState({ cities: cities });
      });
  };

  getWorkOrderAlertsReclaimTypes = async () => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_alerts().reclaim_types(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var reclaim_types = res.data;
        this.setState({ reclaim_types: reclaim_types });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getSinisterTypes = async () => {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.sinisters().types(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var sinister_types = res.data;
        this.setState({ sinister_types });
      })
      .catch(err => {
        console.log(err);
      });
  };
  getSinister = async work_order_id => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.sinisters().work_order_sinister(work_order_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(async res => {
        var {
          shift_date,
          provider_id,
          sinister_broker_code,
          doc_broker_sent_date,
          doc_broker_delivered_date,
          doc_broker_last_reclaim_date,
          doc_layer_sent_date,
          doc_layer_delivered_date,
          doc_layer_last_reclaim_date,
          voucher_code,
          media,
          sinister_type_id,
          sinister_date,
          broker_contact_email,
          lawyer_required,
          total_destruction,
          insurance_ammount,
          resale_ammount,
          insurance_ammount_date,
          resale_ammount_date,
          client_email_content,
          broker_email_content,
          lawyer_not_required_reason,
          media,
          is_reclaimable,
          is_insurance_reclaimable,
          sinister_sector,
          thirdparty_broker,
          insurance_id,
          province_id,
          city_id,
          severity,
          sinister_liability
        } = res.data[0];

        var has_voucher = media.length > 0 ? true : false;
        var provider = res.data[0].provider;
        lawyer_required =
          lawyer_required === 1 || lawyer_required === "1" ? true : false;
        total_destruction =
          total_destruction === 1 || total_destruction === "1" ? true : false;
        is_reclaimable =
          is_reclaimable === 1 || is_reclaimable === "1" ? true : false;
        is_insurance_reclaimable =
          is_insurance_reclaimable === 1 || is_insurance_reclaimable === "1"
            ? true
            : false;
        var id = res.data[0].id;
        var providers = this.state.providers;
        if (provider) {
          providers.options[0].business_name = provider.business_name;
          providers.provider = provider;
        }
        var contact_edit = false;
        if (broker_contact_email !== "") {
          contact_edit = true;
        }
        shift_date = shift_date ? shift_date.replace(" ", "T") : null;

        var documentation_list = res.data[0].documents;
        documentation_list.map((val, idx) => {
          documentation_list[idx].name = val.document.name;
        });
        // add template not loaded yet
        var templates = this.state.sinister_types.filter(
          type => type.id === sinister_type_id
        )[0].templates;
        templates.map((val, idx) => {
          var template = documentation_list.filter(
            doc => doc.name === val.name
          );
          if (template.length === 0) {
            val.media = [];
            documentation_list.push(val);
          }
        });
        this.setState({ providers });
        this.setState({ documentation: documentation_list });
        this.setState({
          id,
          shift_date,
          provider_id,
          sinister_broker_code,
          doc_broker_sent_date,
          doc_broker_delivered_date,
          doc_broker_last_reclaim_date,
          doc_layer_sent_date,
          doc_layer_delivered_date,
          doc_layer_last_reclaim_date,
          voucher_code,
          media,
          sinister_type_id,
          sinister_date,
          broker_contact_email,
          contact_edit,
          lawyer_required,
          total_destruction,
          insurance_ammount,
          resale_ammount,
          client_email_content,
          broker_email_content,
          lawyer_not_required_reason,
          media,
          has_voucher,
          insurance_ammount_date,
          resale_ammount_date,
          is_reclaimable,
          is_insurance_reclaimable,
          sinister_sector,
          thirdparty_broker,
          province_id,
          city_id,
          severity,
          sinister_liability
        });
        if (insurance_id) {
          await this.getInsurance(insurance_id);
        } else {
          this.setState({ insurance: {} });
        }
        var cities = await this.getCities(province_id);
        this.setState({ loaded: true });
        return true;
      })
      .catch(err => {
        console.log(err);
      });
  };

  getInsuranceByPlate = async plate => {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.vehicles().autocomplete(plate), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(async res => {
        var vehicle = this.state.vehicle;
        vehicle = res.data[0];
        if (!this.state.id && vehicle.insurance_id) {
          await this.getInsurance(vehicle.insurance_id);
        }
        this.setState({ vehicle: vehicle, loaded: true });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getInsurance = async id => {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.insurances().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var insurance = this.state.insurance;
        insurance = res.data[0];
        this.setState({ insurance: insurance });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleChange = e => {
    if (
      e.target.name === "insurance_ammount" ||
      e.target.name === "resale_ammount"
    ) {
      e.target.value = e.target.value.replace("$", "");
    }
    if (
      e.target.name === "total_destruction" ||
      e.target.name === "lawyer_required" ||
      e.target.name === "is_insurance_reclaimable" ||
      e.target.name === "is_reclaimable"
    ) {
      this.setState({ [e.target.name]: e.target.checked });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
    if (e.target.name === "sinister_type_id") {
      this.setTemplate(e.target.value);
    }
    if (e.target.name === "province_id") {
      this.getCities(e.target.value);
    }
  };

  handleDocumentationChange = e => {
    var documentation = this.state.documentation;
    var element = e.target.name.split(".");
    var key = element[0];
    var id = element[1];
    documentation[id][key] = e.target.value;
    this.setState({ documentation: documentation });
  };

  handleUploadFile = (file, meta_data) => {
    var documentation = this.state.documentation;
    var media = this.state.media;
    if (meta_data === "voucher") {
      var voucher = {};
      voucher.file = file;
      voucher.meta_data = "voucher";
      media.push(voucher);
    } else {
      var element = meta_data.split(".");
      var key = element[0];
      var id = element[1];
      documentation[id]["file"] = file;
      documentation[id]["template"] = key;
      documentation[id][
        "client_delivered_date"
      ] = new Date().toISOString().slice(0, 10);
      if (key) {
        documentation[id]["meta_data"] = key;
      }
    }
    this.setState({ documentation: documentation, media: media });
  };

  handleProvidersAsyncChange = (event, values) => {
    var providers = this.state.providers;
    values = values !== null ? values : { business_name: "" };
    providers.provider = values;
    this.setState({ providers: providers });
  };

  handleProvidersAsyncSearch = (event, values) => {
    var provider = values;
    const token = localStorage.getItem("userToken");
    if (provider.length > 2) {
      return axios
        .get(api.providers().index(1, provider, "", "", "", ""), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var providers = this.state.providers;
          providers.options = res.data.data;
          this.setState({ providers: providers });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleReclaims = () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.sinisters().reclaims(this.state.id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ reclaims: res.data });
        this.handleDialog();
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleSubmit = () => {
    this.setState({ saving: true });
    var formData = new FormData();
    var sinister_type =
      this.state.sinister_type_id !== ""
        ? this.state.sinister_types.filter(
            type => type.id === this.state.sinister_type_id
          )[0]
        : [];
    var url = this.state.id
      ? api.sinisters().patch(this.state.id)
      : api.sinisters().post();
    formData.set("sinister[work_order_id]", this.props.work_order_id);
    if (!this.state.id) {
      formData.set(
        "sinister[insurance_id]",
        this.state.vehicle.insurance ? this.state.vehicle.insurance.id : ""
      );
    }
    formData.set(
      "sinister[provider_id]",
      this.state.providers
        ? this.state.providers.provider.id
          ? this.state.providers.provider.id
          : ""
        : ""
    );
    formData.set(
      "sinister[shift_date]",
      this.state.shift_date ? this.state.shift_date.replace("T", " ") : ""
    );
    formData.set(
      "sinister[sinister_date]",
      this.state.sinister_date ? this.state.sinister_date : ""
    );
    formData.set(
      "sinister[sinister_broker_code]",
      this.state.sinister_broker_code ? this.state.sinister_broker_code : ""
    );
    formData.set(
      "sinister[sinister_type_id]",
      this.state.sinister_type_id ? this.state.sinister_type_id : ""
    );
    formData.set(
      "sinister[sinister_sector]",
      this.state.sinister_sector ? this.state.sinister_sector : ""
    );
    formData.set(
      "sinister[severity]",
      this.state.sinister_severity ? this.state.sinister_severity : ""
    );
    formData.set(
      "sinister[sinister_liability]",
      this.state.sinister_sinister_liability ? this.state.sinister_sinister_liability : ""
    );
    formData.set(
      "sinister[is_insurance_reclaimable]",
      this.state.is_insurance_reclaimable ? 1 : 0
    );
    formData.set("sinister[is_reclaimable]", this.state.is_reclaimable ? 1 : 0);
    formData.set(
      "sinister[thirdparty_broker]",
      this.state.thirdparty_broker ? this.state.thirdparty_broker : ""
    );

    //	    formData.set("sinister[doc_client_sent_date]", (this.state.doc_client_sent_date) ? this.state.doc_client_sent_date : '');
    //	    formData.set("sinister[doc_client_delivered_date]", (this.state.doc_client_delivered_date) ? this.state.doc_client_delivered_date : '');
    //	    formData.set("sinister[doc_client_last_reclaim_date]", (this.state.doc_client_last_reclaim_date) ? this.state.doc_client_last_reclaim_date : '');
    formData.set(
      "sinister[doc_broker_sent_date]",
      this.state.doc_broker_sent_date ? this.state.doc_broker_sent_date : ""
    );
    formData.set(
      "sinister[doc_broker_delivered_date]",
      this.state.doc_broker_delivered_date
        ? this.state.doc_broker_delivered_date
        : ""
    );
    formData.set(
      "sinister[doc_broker_last_reclaim_date]",
      this.state.doc_broker_last_reclaim_date
        ? this.state.doc_broker_last_reclaim_date
        : ""
    );
    formData.set(
      "sinister[doc_layer_sent_date]",
      this.state.doc_layer_sent_date ? this.state.doc_layer_sent_date : ""
    );
    formData.set(
      "sinister[doc_layer_delivered_date]",
      this.state.doc_layer_delivered_date
        ? this.state.doc_layer_delivered_date
        : ""
    );
    formData.set(
      "sinister[doc_layer_last_reclaim_date]",
      this.state.doc_layer_last_reclaim_date
        ? this.state.doc_layer_last_reclaim_date
        : ""
    );
    formData.set(
      "sinister[voucher_code]",
      this.state.voucher_code ? this.state.voucher_code : ""
    );
    formData.set(
      "sinister[broker_contact_email]",
      this.state.broker_contact_email ? this.state.broker_contact_email : ""
    );
    formData.set(
      "sinister[lawyer_required]",
      this.state.lawyer_required ? 1 : 0
    );
    formData.set(
      "sinister[lawyer_not_required_reason]",
      this.state.lawyer_not_required_reason
        ? this.state.lawyer_not_required_reason
        : ""
    );
    formData.set(
      "sinister[total_destruction]",
      this.state.total_destruction ? 1 : 0
    );
    formData.set(
      "sinister[insurance_ammount]",
      this.state.insurance_ammount ? this.state.insurance_ammount : 0
    );
    formData.set(
      "sinister[resale_ammount]",
      this.state.resale_ammount ? this.state.resale_ammount : 0
    );
    formData.set(
      "sinister[insurance_ammount_date]",
      this.state.insurance_ammount_date ? this.state.insurance_ammount_date : ""
    );
    formData.set(
      "sinister[resale_ammount_date]",
      this.state.resale_ammount_date ? this.state.resale_ammount_date : ""
    );
    formData.set(
      "sinister[client_email_content]",
      this.state.client_email_content ? this.state.client_email_content : ""
    );
    formData.set(
      "sinister[broker_email_content]",
      this.state.broker_email_content ? this.state.broker_email_content : ""
    );

    //client_email_content
    //broker_email_content this.state.broker_email_content
    formData.set(
      "sinister[province_id]",
      this.state.province_id ? this.state.province_id : ""
    );
    formData.set(
      "sinister[city_id]",
      this.state.city_id ? this.state.city_id : ""
    );
    if (this.state.id) {
      formData.set("sinister[id]", this.state.id);
      formData.set("_method", "PATCH");
    }
    var i = 0;
    this.state.media.map((val, idx) => {
      if (val.file) {
        formData.set("media[" + i + "][file]", val.file ? val.file[0] : "");
        formData.set("media[" + i + "][meta_data_name]", "tipo_documento");
        formData.set("media[" + i + "][meta_data_value]", val.meta_data);
        i++;
      }
    });
    var i = 0;
    this.state.documentation.map((val, idx) => {
      if (val.id) {
        formData.set("documentation[" + i + "][id]", val.id ? val.id : "");
      }
      if (sinister_type) {
        var template = sinister_type.templates.filter(
          template => template.name === val.name
        );
        formData.set("documentation[" + i + "][template_id]", template[0].id);
        formData.set(
          "documentation[" + i + "][client_sent_date]",
          val.client_sent_date ? val.client_sent_date : ""
        );
        formData.set(
          "documentation[" + i + "][client_delivered_date]",
          val.client_delivered_date ? val.client_delivered_date : ""
        );
        formData.set(
          "documentation[" + i + "][client_last_reclaim_date]",
          val.client_last_reclaim_date ? val.client_last_reclaim_date : ""
        );
        formData.set(
          "documentation[" + i + "][reclaim_contact_name]",
          val.reclaim_contact_name ? val.reclaim_contact_name : ""
        );
        formData.set(
          "documentation[" + i + "][reclaim_type]",
          val.reclaim_type ? val.reclaim_type : ""
        );
        formData.set("documentation[" + i + "][reclaim_to_type]", "Otros");
        formData.set(
          "documentation[" + i + "][comments]",
          val.comments ? val.comments : ""
        );
        if (val.file) {
          var j = 0;
          val.file.forEach(element => {
            formData.set(
              "documentation[" + i + "][files][" + j + "][file]",
              element
            );
            j++;
          });
        }
        i++;
      }
    });

    /*		if (this.state.files){
			this.state.files.map((val, idx) => {
			  formData.set(`media[${idx}]`, val)
			})
		}
*/
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        self.setState({
          openSuccess: true,
          success_message: "Datos cargados con éxito",
          severity: "success",
          loaded: false
        });
        self.getSinister(this.props.work_order_id);
        self.props.onUpdateWorkOrderState();
        self.setState({ saving: false });
      })
      .catch(function(error) {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }
        } else {
          error_message = "Ha ocurrido un error. Contacte a su administrador";
        }

        self.setState({
          openSuccess: true,
          success_message: error_message,
          severity: "warning"
        });
        self.setState({ saving: false });
      });
  };

  handleDeleteMedia = id => {
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .delete(
        api.media().delete(id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "media[id]": id } }
      )

      .then(response => {
        self.setState({
          openSuccess: true,
          success_message: "Documento eliminado con éxito",
          severity: "warning"
        });
        this.getSinister(this.props.work_order_id);
      })

      .catch(function(error) {
        self.setState({
          openSuccess: true,
          success_message:
            "No pudo borrarse el adjunto. Por favor contacte a su administrador",
          severity: "warning"
        });
      });
  };

  handleCloseSuccess = () => {
    this.setState({ openSuccess: false, success_message: "", severity: "" });
  };

  handleDialog = () => {
    var dialog = this.state.dialog;
    dialog.open = !dialog.open;
    this.setState({ dialog: dialog });
  };

  handleDocumentationExpand = () => {
    var documentation_expand = this.state.documentation_expand;
    documentation_expand = !documentation_expand;
    this.setState({ documentation_expand: documentation_expand });
  };

  handleMailsExpand = () => {
    var mails_expand = this.state.mails_expand;
    mails_expand = !mails_expand;
    this.setState({ mails_expand: mails_expand });
  };

  setTemplate = sinister_type_id => {
    var sinister_type =
      sinister_type_id !== ""
        ? this.state.sinister_types.filter(
            type => type.id === sinister_type_id
          )[0]
        : [];
    this.setState({ documentation: sinister_type.templates });
  };

  handleDownloadTemplate = id => {
    var formData = new FormData();
    const token = localStorage.getItem("userToken");
    axios
      .get(api.sinisters().downloadTemplate(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la Descarga");
      });
  };

  handleContactEdit = () => {
    var contact_edit = !this.state.contact_edit;
    this.setState({ contact_edit });
  };
  render() {
    const classes = this.props.classes;
    var sinister_type = this.state.sinister_types.filter(
      type => type.id === this.state.sinister_type_id
    );
    var template = "";
    if (sinister_type[0]) {
      if (sinister_type[0].template) {
        template = sinister_type[0].template;
      }
    }
    const has_voucher = this.state.has_voucher;
    let sectorsArray = this.state.sinister_sectors;
    if(sinister_type[0] && sinister_type[0].sectors && sinister_type[0].sectors.length > 0){
      sectorsArray = JSON.parse(sinister_type[0].sectors);
    }
    const liabilityArray = [
      { id: "Tercero", name: "Tercero" },
      { id: "Propio", name: "Propio" },
    ];
    const severityArray = [
      { id: "Leve", name: "Leve" },
      { id: "Moderado", name: "Moderado" },
      { id: "Severo", name: "Severo" },
    ];
    return (
      <div className="mt-2">
        <Snackbar
          open={this.state.openSuccess}
          autoHideDuration={10000}
          onClose={this.handleCloseSuccess}
        >
          <Alert
            onClose={this.handleCloseSuccess}
            severity={this.state.severity}
          >
            {this.state.success_message}
          </Alert>
        </Snackbar>

        {this.state.loaded ? (
          <React.Fragment>
            <Dialog
              fullScreen
              open={this.state.dialog.open}
              onClose={this.handleDialog}
            >
              <AppBar className="mt-2">
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={this.handleDialog}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography
                    variant="h6"
                    className={classes.title}
                    style={{ color: "white" }}
                  >
                    Reclamos
                  </Typography>
                </Toolbar>
              </AppBar>
              <DialogContent className="mt-4">
                <DialogContentText
                  id="alert-dialog-description"
                  className="mt-5 mb-4"
                >
                  <div className="row mt-5 mb-5 ml-4">
                    <Table
                      size="small"
                      aria-label="a dense table"
                      style={{ width: "auto", minWidth: "650px" }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ fontWeight: "550" }}>
                            Fecha Reclamo
                          </TableCell>
                          <TableCell style={{ fontWeight: "550" }}>
                            Dirigido a
                          </TableCell>
                          <TableCell style={{ fontWeight: "550" }}>
                            Forma de reclamo
                          </TableCell>
                          <TableCell style={{ fontWeight: "550" }}>
                            Documento
                          </TableCell>
                          <TableCell style={{ fontWeight: "550" }}>
                            Comentarios
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.reclaims.length > 0 ? (
                          this.state.reclaims.map((val, idx) => {
                            return (
                              <TableRow key={idx}>
                                <TableCell
                                  className=""
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {val.reclaim_date}
                                </TableCell>
                                <TableCell
                                  className=""
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {val.reclaim_contact_name}
                                </TableCell>
                                <TableCell
                                  className=""
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {val.reclaim_type}
                                </TableCell>
                                <TableCell
                                  className=""
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {val.reclaim_document}
                                </TableCell>
                                <TableCell
                                  className=""
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {val.comments}
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableCell colSpan={4}>No hay reclamos aún</TableCell>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </DialogContentText>
              </DialogContent>
            </Dialog>
            <div className="row mt-2">
              {this.state.id ? (
                <TextField
                  id="insurance_provider_busniess_name"
                  value={
                    this.state.insurance &&
                    this.state.insurance.broker &&
                    this.state.insurance.broker.provider
                      ? this.state.insurance.broker.provider.business_name
                      : "Sin seguro al cargarse"
                  }
                  onChange={this.handleChange}
                  disabled={true}
                  type="text"
                  name="insurance_provider_busniess_name"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 250, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Broker</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              ) : (
                <TextField
                  id="insurance_provider_busniess_name"
                  value={
                    this.state.vehicle.insurance
                      ? this.state.vehicle.insurance.broker.provider
                          .business_name
                      : "Sin seguro"
                  }
                  onChange={this.handleChange}
                  disabled={true}
                  type="text"
                  name="insurance_provider_busniess_name"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 250, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Broker</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              )}
              <TextField
                id="insurance_type_id"
                value={
                  this.state.insurance && this.state.insurance.type
                    ? this.state.insurance.type.name
                    : "Sin seguro"
                }
                onChange={this.handleChange}
                disabled={true}
                type="text"
                name="insurance_type_id"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 250, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Tipo Seguro</Typography>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="insurance_name"
                value={
                  this.state.insurance && this.state.insurance.name
                    ? this.state.insurance.name
                    : "Sin seguro"
                }
                onChange={this.handleChange}
                disabled={true}
                type="text"
                name="insurance_name"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem", minWidth: 250 } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Nombre Seguro</Typography>
                      <ViewIcon
                        fontSize="small"
                        disabled={this.state.vehicle.insurance ? false : true}
                        onClick={() =>
                          window.open(
                            "/insurance/" + this.state.insurance.id + "/0"
                          )
                        }
                      />
                    </InputAdornment>
                  )
                }}
              />
              {this.state.insurance && this.state.insurance.media
                ? this.state.insurance.media.map((val, idx) => {
                    if (val.custom_properties !== undefined) {
                      return (
                        <React.Fragment>
                          <Link
                            className="mr-2"
                            href={api.media_download + "/" + val.id}
                            style={{ fontSize: "0.8rem" }}
                          >
                            <ArrowDownwardIcon
                              style={{ height: "0.8rem", width: "0.8rem" }}
                            />
                            Descargar {val.custom_properties.tipo_documento}
                          </Link>
                        </React.Fragment>
                      );
                    }
                  })
                : ""}
            </div>
            <div class="row mt-2">
              <NumberFormat
                id="insurance_franchise"
                name="insurance_franchise"
                value={
                  this.props.insurance_franchise
                    ? this.props.insurance_franchise
                    : ""
                }
                disabled={true}
                className="mr-2"
                InputProps={{
                  style: { fontSize: "0.75rem", width: 250 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Franquicia poliza
                      </Typography>
                    </InputAdornment>
                  )
                }}
                thousandSeparator="."
                decimalSeparator=","
                prefix={"$"}
                customInput={TextField}
                InputLabelProps={{
                  shrink: true
                }}
              />

              <NumberFormat
                id="franchise"
                business_name="franchise"
                value={
                  this.state.active_booking
                    ? this.state.active_booking.franchise
                    : 0
                }
                disabled={true}
                className="mr-2"
                InputProps={{
                  style: { fontSize: "0.75rem", width: 250 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Franquicia contrato
                      </Typography>
                    </InputAdornment>
                  )
                }}
                thousandSeparator=","
                decimalSeparator="."
                prefix={"$"}
                customInput={TextField}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </div>

            <div class="row mt-2">
              <NumberFormat
                id="insurance_ammount"
                name="insurance_ammount"
                value={
                  this.state.vehicle.insurance_ammount
                    ? this.state.vehicle.insurance_ammount
                    : "Sin monto cargado"
                }
                disabled={true}
                className="mr-2"
                InputProps={{
                  style: { fontSize: "0.75rem", width: 250 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Monto asegurado</Typography>
                    </InputAdornment>
                  )
                }}
                decimalSeparator=","
                thousandSeparator="."
                prefix={"$"}
                customInput={TextField}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <NumberFormat
                id="franchise_percentage"
                name="franchise_percentage"
                value={
                  this.state.vehicle.insurance
                    ? this.state.vehicle.insurance.franchise_percentage
                    : "Sin seguro cargado"
                }
                disabled={true}
                className="mr-2"
                InputProps={{
                  style: { fontSize: "0.75rem", width: 180 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Franquicia poliza (%)
                      </Typography>
                    </InputAdornment>
                  )
                }}
                thousandSeparator=","
                decimalSeparator="."
                prefix={"%"}
                customInput={TextField}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <NumberFormat
                id="insurance_ammount_calculated"
                name="insurance_ammount_calculated"
                value={
                  this.state.vehicle.insurance
                    ? Number(
                        (this.state.vehicle.insurance.franchise_percentage *
                          this.state.vehicle.insurance_ammount) /
                          100
                      )
                    : 0
                }
                disabled={true}
                className="mr-2"
                InputProps={{
                  style: { fontSize: "0.75rem", width: 250 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Franquicia calculada
                      </Typography>
                    </InputAdornment>
                  )
                }}
                thousandSeparator="."
                decimalSeparator=","
                prefix={"$"}
                customInput={TextField}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </div>
            <div className="row mt-2">
              <TextField
                id="sinister_type_id"
                placeholder="Ingrese el tipo de siniestro"
                name="sinister_type_id"
                onChange={this.handleChange}
                value={this.state.sinister_type_id}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography
                        variant="caption"
                        style={{ width: "fitContent" }}
                      >
                        Tipo Siniestro{" "}
                        {this.state.sinister_type_id ? (
                          <CloudDownloadIcon
                            onClick={e => window.open(template)}
                          />
                        ) : (
                          ""
                        )}
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {this.state.sinister_types.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.menu}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="sinister_sector"
                placeholder="Ingrese el sector de siniestro"
                name="sinister_sector"
                onChange={this.handleChange}
                value={this.state.sinister_sector}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography
                        variant="caption"
                        style={{ width: "fitContent" }}
                      >
                        Sector
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {sectorsArray.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.menu}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                id="sinister_severity"
                placeholder="Ingrese la severidad del siniestro"
                name="sinister_severity"
                onChange={this.handleChange}
                value={this.state.sinister_severity}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography
                        variant="caption"
                        style={{ width: "fitContent" }}
                      >
                        Severidad
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {severityArray.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.menu}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                id="sinister_sinister_liability"
                placeholder="Ingrese la responsabilidad del siniestro"
                name="sinister_sinister_liability"
                onChange={this.handleChange}
                value={this.state.sinister_sinister_liability}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography
                        variant="caption"
                        style={{ width: "fitContent" }}
                      >
                        Responsabilidad
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {liabilityArray.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.menu}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="sinister_date"
                value={this.state.sinister_date}
                onChange={this.handleChange}
                type="datetime-local"
                name="sinister_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Fecha siniestro</Typography>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="province_id"
                placeholder="Ingrese la provincia del siniestro"
                name="province_id"
                onChange={this.handleChange}
                value={this.state.province_id}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography
                        variant="caption"
                        style={{ width: "fitContent" }}
                      >
                        Provincia siniestro{" "}
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {this.state.provinces.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.menu}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              {this.state.province_id !== "" && this.state.cities.length > 0 ? (
                <TextField
                  id="city_id"
                  placeholder="Ingrese la ciudad del siniestro"
                  name="city_id"
                  onChange={this.handleChange}
                  value={this.state.city_id}
                  select
                  margin="normal"
                  className="mr-2 mt-0"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          variant="caption"
                          style={{ width: "fitContent" }}
                        >
                          Ciudad siniestro{" "}
                        </Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                >
                  {this.state.cities.map(option => (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                      className={classes.menu}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              ) : (
                " "
              )}
              <TextField
                id="broker_contact_email"
                placeholder="Ingrese el contacto del broker"
                name="broker_contact_email"
                onChange={this.handleChange}
                value={this.state.broker_contact_email}
                select={!this.state.contact_edit}
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography
                        variant="caption"
                        style={{ width: "fitContent" }}
                      >
                        Contacto broker{" "}
                        <EditIcon
                          fontSize="small"
                          onClick={e => this.handleContactEdit()}
                        />
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {this.state.insurance &&
                  this.state.insurance.subcontacts &&
                  this.state.insurance.subcontacts.map(option => (
                    <MenuItem
                      key={option.subcontact.contact.email}
                      value={option.subcontact.contact.email}
                      className={classes.menu}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {option.subcontact.firstname} {option.subcontact.lastname}{" "}
                      ({option.subcontact.contact.email})
                    </MenuItem>
                  ))}
              </TextField>

              <TextField
                id="sinister_broker_code"
                value={this.state.sinister_broker_code}
                onChange={this.handleChange}
                type="text"
                name="sinister_broker_code"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Número siniestro broker
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name={"is_reclaimable"}
                    id={"is_reclaimable"}
                    value={this.state.is_reclaimable}
                    checked={this.state.is_reclaimable}
                    onChange={this.handleChange}
                    className="pt-0"
                  />
                }
                label={
                  <Typography variant="caption">Es reclamable?</Typography>
                }
                labelPlacement="start"
                className="ml-0 mr-1"
                style={{ alignItems: "normal" }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name={"is_insurance_reclaimable"}
                    id={"is_insurance_reclaimable"}
                    value={this.state.is_insurance_reclaimable}
                    checked={this.state.is_insurance_reclaimable}
                    onChange={this.handleChange}
                    className="pt-0"
                  />
                }
                label={
                  <Typography variant="caption">
                    Es reclamable seguro?
                  </Typography>
                }
                labelPlacement="start"
                className="ml-0 mr-1"
                style={{ alignItems: "normal" }}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name={"lawyer_required"}
                    id={"lawyer_required"}
                    value={this.state.lawyer_required}
                    checked={this.state.lawyer_required}
                    onChange={this.handleChange}
                    className="pt-0"
                  />
                }
                label={
                  <Typography variant="caption">Requiere abogado?</Typography>
                }
                labelPlacement="start"
                className="ml-0 mr-1"
                style={{ alignItems: "normal" }}
              />
              {!(
                this.state.lawyer_required === true ||
                this.state.lawyer_required === "true"
              ) ? (
                <TextField
                  id="lawyer_not_required_reason"
                  value={this.state.lawyer_not_required_reason}
                  onChange={this.handleChange}
                  type="text"
                  name="lawyer_not_required_reason"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 250, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Motivo de no requerir
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                />
              ) : (
                ""
              )}
              <FormControlLabel
                control={
                  <Checkbox
                    name={"total_destruction"}
                    id={"total_destruction"}
                    value={this.state.total_destruction}
                    checked={this.state.total_destruction}
                    onChange={this.handleChange}
                    className="pt-0"
                  />
                }
                label={
                  <Typography variant="caption">
                    Es destrucción total?
                  </Typography>
                }
                labelPlacement="start"
                className="ml-0 mr-1"
                style={{ alignItems: "normal" }}
              />

              {this.state.lawyer_required === true ||
              this.state.lawyer_required === "true" ||
              this.state.total_destruction === true ||
              this.state.total_destruction === "true" ? (
                <React.Fragment>
                  {this.state.total_destruction !== true ||
                  this.state.total_destruction !== "true" ? (
                    <TextField
                      id="thirdparty_broker"
                      value={this.state.thirdparty_broker}
                      onChange={this.handleChange}
                      type="text"
                      name="thirdparty_broker"
                      margin="normal"
                      className="m-0 p-0 mr-2"
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        style: { minWidth: 70, fontSize: "0.75rem" }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">
                              Aseguradora Tercero
                            </Typography>
                          </InputAdornment>
                        )
                      }}
                    />
                  ) : (
                    ""
                  )}
                  <NumberFormat
                    id="insurance_ammount"
                    name="insurance_ammount"
                    onChange={this.handleChange}
                    value={
                      this.state.insurance_ammount
                        ? this.state.insurance_ammount
                        : 0
                    }
                    className="mr-2"
                    InputProps={{
                      style: { fontSize: "0.75rem", width: 250 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Monto de pago seguro
                          </Typography>
                        </InputAdornment>
                      )
                    }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <TextField
                    id="insurance_ammount_date"
                    value={this.state.insurance_ammount_date}
                    onChange={this.handleChange}
                    type="date"
                    name="insurance_ammount_date"
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Fecha pago seguro
                          </Typography>
                        </InputAdornment>
                      )
                    }}
                  />
                </React.Fragment>
              ) : (
                ""
              )}
              {this.state.total_destruction === true ||
              this.state.total_destruction === "true" ? (
                <>
                  <NumberFormat
                    id="resale_ammount"
                    name="resale_ammount"
                    onChange={this.handleChange}
                    value={
                      this.state.resale_ammount ? this.state.resale_ammount : 0
                    }
                    className="mr-2"
                    InputProps={{
                      style: { fontSize: "0.75rem", width: 250 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Monto reventa
                          </Typography>
                        </InputAdornment>
                      )
                    }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <TextField
                    id="resale_ammount_date"
                    value={this.state.resale_ammount_date}
                    onChange={this.handleChange}
                    type="date"
                    name="resale_ammount_date"
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Fecha reventa
                          </Typography>
                        </InputAdornment>
                      )
                    }}
                  />
                </>
              ) : (
                ""
              )}
            </div>
            <div className="row mt-2">
              <TextField
                id="voucher_code"
                value={this.state.voucher_code}
                onChange={this.handleChange}
                type="text"
                name="voucher_code"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Voucher</Typography>
                    </InputAdornment>
                  )
                }}
              />
              {!has_voucher ? (
                <MediaFile
                  onChange={this.handleUploadFile}
                  title="Agregar voucher"
                  width={"15rem"}
                  height={"2rem"}
                  meta_data="voucher"
                />
              ) : (
                <React.Fragment>
                  <Link
                    href={api.media_download + "/" + this.state.media[0].id}
                    className="mr-1"
                    style={{ fontSize: "0.7rem" }}
                  >
                    <ArrowDownwardIcon />
                    Descargar voucher
                  </Link>
                  <Button
                    onClick={e => {
                      this.handleDeleteMedia(this.state.media[0].id);
                    }}
                    style={{ fontSize: "0.7rem", textTransform: "none" }}
                  >
                    <CancelIcon style={{ height: "0.8rem", width: "0.8rem" }} />{" "}
                    Eliminar voucher
                  </Button>
                </React.Fragment>
              )}

              {this.state.provider_id > 0 ? (
                <TextField
                  id="provider_business_name"
                  value={this.state.providers.provider.business_name}
                  //onChange={this.handleChange}
                  type="text"
                  disabled
                  name="provider_business_name"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { width: 150, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Proveedor</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              ) : (
                <Autocomplete
                  id="provider"
                  style={{ width: 200 }}
                  getOptionLabel={option => option.business_name}
                  getOptionSelected={(option, value) =>
                    option.business_name === value
                  }
                  options={this.state.providers.options}
                  loading={this.state.providers.loading}
                  onInputChange={this.handleProvidersAsyncSearch}
                  onChange={this.handleProvidersAsyncChange.bind(this)}
                  value={this.state.providers.options.find(
                    v =>
                      v.business_name ===
                      this.state.providers.provider.business_name
                  )}
                  autoComplete
                  noOptionsText={
                    <Typography variant="caption">Sin resultados</Typography>
                  }
                  name="provider"
                  includeInputInList
                  className="mt-1 mr-2"
                  classes={{
                    option: classes.option
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      placeholder="Ingrese un proveedor"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {this.state.providers.loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                        startAdornment: (
                          <Typography variant="caption">Proveedor</Typography>
                        )
                      }}
                      InputLabelProps={{
                        ...params.InputLabelProps,
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: "0.75rem", width: 70 }
                      }}
                    />
                  )}
                />
              )}

              <TextField
                id="shift_date"
                value={this.state.shift_date}
                onChange={this.handleChange}
                type="datetime-local"
                name="shift_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { width: 150, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Fecha turno</Typography>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div className="row mt-2">
              <Typography variant="subtitle">Documentación Cliente</Typography>
              {this.state.documentation_expand ? (
                <ExpandLessIcon
                  onClick={e => this.handleDocumentationExpand()}
                />
              ) : (
                <ExpandMoreIcon
                  onClick={e => this.handleDocumentationExpand()}
                />
              )}
            </div>
            {this.state.documentation_expand ? (
              <div className="row mt-1">
                {this.state.sinister_type_id !== ""
                  ? this.state.documentation.map((val, idx) => {
                      var media = val.media ? val.media : [];
                      var template = {};
                      var template_id = "";
                      if (val.sinister_id) {
                        template = val.document.template;
                        template_id = val.template_id;
                      } else {
                        template = val.template;
                        template_id = val.id;
                      }
                      return (
                        <React.Fragment>
                          <div className="mt-2">
                            <TextField
                              id={"client_sent_date." + idx}
                              value={val.client_sent_date}
                              onChange={this.handleDocumentationChange}
                              type="date"
                              name={"client_sent_date." + idx}
                              margin="normal"
                              className="m-0 p-0 mr-2"
                              InputLabelProps={{
                                shrink: true
                              }}
                              inputProps={{
                                style: { width: 115, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography variant="caption">
                                      Envio
                                    </Typography>
                                  </InputAdornment>
                                )
                              }}
                            />
                            <TextField
                              id={"client_delivered_date." + idx}
                              value={val.client_delivered_date}
                              onChange={this.handleDocumentationChange}
                              type="date"
                              name={"client_delivered_date." + idx}
                              margin="normal"
                              className="m-0 p-0 mr-2"
                              InputLabelProps={{
                                shrink: true
                              }}
                              inputProps={{
                                style: { width: 115, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography variant="caption">
                                      Recepción
                                    </Typography>
                                  </InputAdornment>
                                )
                              }}
                            />
                            <TextField
                              id={"client_last_reclaim_date." + idx}
                              value={val.client_last_reclaim_date}
                              onChange={this.handleDocumentationChange}
                              type="date"
                              name={"client_last_reclaim_date." + idx}
                              margin="normal"
                              className="m-0 p-0 mr-2"
                              InputLabelProps={{
                                shrink: true
                              }}
                              inputProps={{
                                style: { width: 115, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography variant="caption">
                                      Ult. reclamo
                                    </Typography>
                                  </InputAdornment>
                                )
                              }}
                            />
                            <TextField
                              id={"reclaim_type." + idx}
                              value={val.reclaim_type}
                              onChange={this.handleDocumentationChange}
                              margin="normal"
                              select
                              name={"reclaim_type." + idx}
                              className="m-0 p-0 mr-2"
                              InputLabelProps={{
                                shrink: true
                              }}
                              inputProps={{
                                style: { width: 50, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                style: { fontSize: "0.75rem" },
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography variant="caption">
                                      Tipo reclamo
                                    </Typography>
                                  </InputAdornment>
                                )
                              }}
                            >
                              {this.state.reclaim_types.map(option => (
                                <MenuItem
                                  key={option}
                                  value={option}
                                  className={classes.menu}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </TextField>

                            {/*<TextField
												id={"reclaim_type."+idx}
												value={val.reclaim_type}
												onChange={this.handleDocumentationChange}
												type="text"
												name={"reclaim_type."+idx}
												margin="normal"
												className="m-0 p-0 mr-2"
												InputLabelProps={{
													shrink: true
												}}
												inputProps={{style:{width: 50, fontSize: '0.75rem'}}}
												InputProps={{
												    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Tipo reclamo</Typography></InputAdornment>,
												}}
											/>*/}
                            <TextField
                              id={"reclaim_contact_name." + idx}
                              value={val.reclaim_contact_name}
                              onChange={this.handleDocumentationChange}
                              type="text"
                              name={"reclaim_contact_name." + idx}
                              margin="normal"
                              className="m-0 p-0 mr-2"
                              InputLabelProps={{
                                shrink: true
                              }}
                              inputProps={{
                                style: { width: 80, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography variant="caption">
                                      Reclamo a
                                    </Typography>
                                  </InputAdornment>
                                )
                              }}
                            />
                            <TextField
                              id={"comments." + idx}
                              value={val.comments}
                              onChange={this.handleDocumentationChange}
                              type="text"
                              name={"comments." + idx}
                              margin="normal"
                              className="m-0 p-0 mr-2"
                              InputLabelProps={{
                                shrink: true
                              }}
                              inputProps={{
                                style: { width: 120, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography variant="caption">
                                      Comentarios
                                    </Typography>
                                  </InputAdornment>
                                )
                              }}
                            />
                            <div className="mt-1">
                              {media.length > 0 ? (
                                media.map((val, idx) => {
                                  return (
                                    <React.Fragment>
                                      <Link
                                        href={api.media_download + "/" + val.id}
                                        style={{ fontSize: "0.8rem" }}
                                      >
                                        <ArrowDownwardIcon
                                          style={{
                                            height: "0.8rem",
                                            width: "0.8rem"
                                          }}
                                        />
                                        Descargar
                                      </Link>
                                      <Button
                                        onClick={e => {
                                          this.handleDeleteMedia(val.id);
                                        }}
                                        style={{
                                          fontSize: "0.8rem",
                                          textTransform: "none"
                                        }}
                                      >
                                        <CancelIcon
                                          style={{
                                            height: "0.8rem",
                                            width: "0.8rem"
                                          }}
                                        />{" "}
                                        Eliminar {val.name}
                                      </Button>
                                    </React.Fragment>
                                  );
                                })
                              ) : (
                                <React.Fragment>
                                  <Button
                                    className={
                                      template !== null ? "" : "d-none"
                                    }
                                    onClick={e => {
                                      this.handleDownloadTemplate(template_id);
                                    }}
                                    style={{
                                      fontSize: "0.8rem",
                                      textTransform: "none"
                                    }}
                                  >
                                    <ArrowDownwardIcon
                                      style={{
                                        height: "0.8rem",
                                        width: "0.8rem"
                                      }}
                                    />
                                    Descargar template
                                  </Button>
                                  <MediaFile
                                    onChange={this.handleUploadFile}
                                    title={"Cargar " + val.name}
                                    width={"15rem"}
                                    height={"2rem"}
                                    meta_data={val.name + "." + idx}
                                    noRow={true}
                                  />
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })
                  : ""}
              </div>
            ) : (
              ""
            )}

            <div className="row mt-2 d-none">
              <Typography variant="subtitle">Contenido Mails</Typography>
              {this.state.mails_expand ? (
                <ExpandLessIcon onClick={e => this.handleMailsExpand()} />
              ) : (
                <ExpandMoreIcon onClick={e => this.handleMailsExpand()} />
              )}
            </div>
            {this.state.mails_expand ? (
              <div className="row mt-1">
                <TextField
                  id={"client_email_content"}
                  value={this.state.client_email_content}
                  onChange={this.handleChange}
                  type="text"
                  name={"client_email_content"}
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                  inputProps={{ style: { fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Mail cliente</Typography>
                      </InputAdornment>
                    )
                  }}
                />
                <TextField
                  id={"broker_email_content"}
                  value={this.state.broker_email_content}
                  onChange={this.handleChange}
                  type="text"
                  name={"broker_email_content"}
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                  inputProps={{ style: { fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Mail broker</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              </div>
            ) : (
              ""
            )}

            <div className="row mt-2">
              <Typography variant="subtitle">Fechas</Typography>
            </div>
            <div className="row mt-2">
              <TextField
                id="doc_broker_sent_date"
                value={this.state.doc_broker_sent_date}
                onChange={this.handleChange}
                type="date"
                name="doc_broker_sent_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Envio. doc broker
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="doc_broker_delivered_date"
                value={this.state.doc_broker_delivered_date}
                onChange={this.handleChange}
                type="date"
                name="doc_broker_delivered_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Entrega. doc broker
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="doc_broker_last_reclaim_date"
                value={this.state.doc_broker_last_reclaim_date}
                onChange={this.handleChange}
                type="date"
                name="doc_broker_last_reclaim_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Ult. reclamo doc Broker
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div className="row mt-2">
              <TextField
                id="doc_layer_sent_date"
                value={this.state.doc_layer_sent_date}
                onChange={this.handleChange}
                type="date"
                name="doc_layer_sent_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Envio. doc abogado
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="doc_layer_delivered_date"
                value={this.state.doc_layer_delivered_date}
                onChange={this.handleChange}
                type="date"
                name="doc_layer_delivered_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Entrega. doc abogado
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="doc_layer_last_reclaim_date"
                value={this.state.doc_layer_last_reclaim_date}
                onChange={this.handleChange}
                type="date"
                name="doc_layer_last_reclaim_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Ult. reclamo doc abogado
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div className="row mt-1">
              <Button
                className="mr-2"
                disabled={this.state.id ? false : true}
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={e => {
                  this.handleReclaims(e);
                }}
              >
                Ver más reclamos
              </Button>
            </div>
            <div className="row mt-1">
              <Button
                disabled={this.state.saving ? true : false}
                className="mr-2"
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={e => {
                  this.handleSubmit(e);
                }}
              >
                Guardar
              </Button>
            </div>
          </React.Fragment>
        ) : (
          <LinearProgress />
        )}
      </div>
    );
  }
}
export default withStyles(useStyles)(Sinister);
